import { ActionTree } from 'vuex'

import { ContributerState, RootState } from '@/types/store'

import { getContributers } from '@/api/receipts'

export const actions: ActionTree<ContributerState, RootState> = {
  async getContributers({ commit }, query): Promise<void> {
    commit('contributersLoaded', [])
    commit('contributersLoadStart', true)
    const contributers = await getContributers(query)
    commit('contributersLoaded', contributers)
  },
  reset({ commit }): void {
    commit('contributersLoaded', [])
  },
}
